/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Wholesale Registration Form
  if($("#wholesale_register").length > 0) {

    $("#wholesale_register").validate({
      rules: {
          first_name: "required",
          last_name: "required",
          business_name: "required",
          phone: "required",
          street_address: "required",
          city: "required",
          state: "required",
          zip_code: "required",
          country: "required",
          business_instagram_or_website_link: "required",
          'open_account[]': {
            required: true,
            // maxlength: 2
          },
          password: {
            required: true,
            minlength: 5
          },
          password_confirmation: {
            required: true,
            minlength: 5,
            equalTo: "#password"
          },
          email: {
            required: true,
            email: true
          },
        },
        messages: {
          first_name: "Please enter your firstname",
          last_name: "Please enter your lastname",
          password: {
            required: "Please provide a password",
            minlength: "Your password must be at least 5 characters long"
          },
          password_confirmation: {
            required: "Please provide a password",
            minlength: "Your password must be at least 5 characters long",
            equalTo: "Please enter the same password as above"
          },
          email: "Please enter a valid email address",
          'open_account[]': {
                required: "You must check at least 1 box",
                maxlength: "Check no more than {0} boxes"
            }
        }
    });
  }


  $(document).on('submit','#wholesale_register',function(e){
    e.preventDefault();

    var values = {};
    values['oppen_account'] = []

    $.each($(this).serializeArray(), function(i, field) {
      if(field.name == 'open_account[]') {
        values['oppen_account'].push(field.values)
      } else {
        values[field.name] = field.value;
      }
    });

    var formData = new FormData(this);

    if(values) {

      var button = $(this).find('.btn');
      button.find('span').addClass('hide');
      button.find('svg').removeClass('hide');
      button.prop("disabled", true);
      
      if(window.location.hash == '#test') {
      	var ajax_url = 'https://17b6f06d9309.ngrok.io/wholesale-registration';
      } else {
      	var ajax_url = 'https://wholesalebjo-cms.herokuapp.com/wholesale-registration';
      }
      
      console.log(ajax_url)

      $.ajax({
        type: "POST",
        url: ajax_url,
        data:new FormData(this),
        dataType:'JSON',
        contentType: false,
        cache: false,
        processData: false,
        success: function(response){
          console.log(response);

          if(response.success) {
            button.find('span').removeClass('hide');
            button.find('svg').addClass('hide');
            button.prop("disabled", false);
          }

          $('.form-message').removeClass('hide').addClass('note--success').html(response.message)

          document.getElementById("wholesale_register").reset();
        },
        error: function(xhr, status, error) {
          $('.form-message').removeClass('hide').addClass('errors').html('Something went wrong. Please contact site Administrator!')
          console.log(JSON.stringify(xhr));
        }
      });
    }
  });


// remove WHL & PROTEAM tags
/*$(function(){
  
  $("body").on('DOMSubtreeModified', ".ProductForm__OptionName", function () {
	var selected_variant = '';
   
    if($('.ProductForm__SelectedValue')){
      
      $('.ProductForm__OptionName').each(function(){
       	selected_variant = $(this).find('.ProductForm__SelectedValue').text();
        
        selected_variant_changed = selected_variant.replace('PROTEAM-', '').replace('WHL-','');
        
        if(selected_variant_changed !== selected_variant){
        	$(this).find('.ProductForm__SelectedValue').text(selected_variant_changed)
      	}
      })
    }

  })
  
  if($('ProductForm__OptionName .ProductForm__SelectedValue')){
    $('.ProductForm__SelectedValue').text(function(_,old_text){
        return old_text.replace('PROTEAM-','').replace('WHL-','');
    });
  }
  
  //---
  
  if($('.Cart__ItemList')){
    $('.CartItem__Variant').text(function(_,old_text){
        return old_text.replace(/PROTEAM-/g, '').replace(/WHL-/g,'');
    });
  }
  
  if($('.product')){
    $('.order-summary__small-text').text(function(_,old_text){
        return old_text.replace(/PROTEAM-/g, '').replace(/WHL-/g,'');
    });
  }
  
  //---
  
  
  $('.ProductForm__Option button').on('click',function(e){
    if($('.Popover__ValueList').length){
      $('.Popover__ValueList button').each(function() {
        $(this).html(function(index, text) {
          if(text.indexOf('WHL-') > -1){
            return text.replace('WHL-', '');
          } else if (text.indexOf('PROTEAM-') > -1){
            return text.replace('PROTEAM-', '');
          }
        });
      })
    }
  })

})*/


